const selectDiamondType = async (selectedData, dataHouse) => {

    if (selectedData.trim() === 'all') {
        // If the search term is all, return the whole array
        return dataHouse;
    }
    const selectedStockData = await dataHouse.filter((data) => {
        return data.diamond_type.toLowerCase().includes(selectedData.toLowerCase());
    });
    return selectedStockData;
};
const selectEntryMonth = async (selectedData, dataHouse) => {
    if (typeof selectedData !== 'number') {

        if (selectedData.trim() === 'all') {
            // If the search term is all, return the whole array
            return dataHouse;
        }
    }
    else {
        const filteredMonthData = [];
        dataHouse.forEach((data) => {
            const date = new Date(data.date_of_purchase);
            const month = date.getMonth() + 1;
            if (month === selectedData) {
                filteredMonthData.push(data);
            }
        });

        return filteredMonthData;
    }
};

export { selectDiamondType, selectEntryMonth }
